import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as actions from 'actions/shared/index/data';
import { Icon } from 'ui';
import Popover from 'components/shared/popover';
import { hasPermission } from '../../selectors';
import ActionButton from '../shared/ActionButton';
import CalculateInformation from './advanced/CalculateInformation';
import ExportAllPeopleButton from './ExportAllPeopleButton';
import { routes } from '../../constants/config';

class PeopleHeaderButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.editRulesButton = this.editRulesButton.bind(this);
    this.groupDetailsButton = this.groupDetailsButton.bind(this);
    this.editGroupMembersButton = this.editGroupMembersButton.bind(this);
    this.addNewButtons = this.addNewButtons.bind(this);
  }

  toggleMenu() {
    this.setState(state => ({ isActive: !state.isActive }));
  }

  editRulesButton() {
    const isSmartGroup =
      this.props.activeGroupType &&
      this.props.activeGroupType === 'Group::Smart';

    return (
      isSmartGroup &&
      this.props.canEditSmartGroups &&
      !this.props.hasUnificationFeatureFlag && (
        <ActionButton
          label="Edit Rules"
          disabled={this.props.activeGroupCalculating}
          handleClick={() =>
            this.props.editRuleBasedGroup(this.props.activeGroupId)
          }
          iconName="edit"
        />
      )
    );
  }

  groupDetailsButton() {
    let groupId;

    if (this.props.activeGroupId) {
      groupId = this.props.activeGroupId;
    } else {
      groupId = this.props.everyoneGroupId;
    }

    return (
      (this.props.canExportPeople || this.props.activeGroupId) &&
      groupId && (
        <ActionButton
          label={t('groups.group_details')}
          disabled={this.props.activeGroupCalculating}
          href={routes.GROUPS + '/' + groupId}
          iconName="import"
        />
      )
    );
  }

  editGroupMembersButton() {
    const canEditGroupMembers = this.props.activeGroupType === 'Group';

    return (
      canEditGroupMembers &&
      this.props.canAddPeople && (
        <ActionButton
          label="Edit Group Members"
          href={routes.GROUPS + '/' + this.props.activeGroupId + '/edit'}
          iconName="edit"
        />
      )
    );
  }

  addNewButtons() {
    const isSystemGeneratedGroup =
      this.props.activeGroupType === 'Group::SystemGenerated';
    return (
      <div>
        {this.props.canAddPeople &&
          !isSystemGeneratedGroup &&
          !this.props.hasUnificationFeatureFlag && (
            <ActionButton
              label={t('people.new_person')}
              href={routes.NEW_USER}
              iconName="add"
              disabled={!this.props.hasManagedGroups}
              data-toggle={!this.props.hasManagedGroups ? 'tooltip' : null}
              data-original-title={
                !this.props.hasManagedGroups
                  ? t('groups.no_managed_group')
                  : null
              }
              pendoClassName="trk_button_people-new-person"
            />
          )}
        {!this.props.activeGroupId &&
          this.props.canAddPeople &&
          !this.props.hasUnificationFeatureFlag && (
            <ActionButton
              label={t('groups.new_group')}
              href={routes.NEW_GROUP}
              iconName="add"
              pendoClassName="trk_button_people-new-group"
            />
          )}
        {!this.props.activeGroupId &&
          this.props.canEditSmartGroups &&
          !this.props.hasUnificationFeatureFlag && (
            <ActionButton
              label={t('smart_groups.new')}
              handleClick={e => this.props.createNewRuleBasedGroup()}
              iconName="add"
              pendoClassName="trk_button_people-new-smart-group"
            />
          )}
      </div>
    );
  }

  render() {
    const {
      activeGroupCalculating,
      activeGroupRecalculationState,
      activeGroupId,
      activeGroupType,
      canAddPeople,
      canExportPeople,
      refreshData,
      setGroupInMeta,
      hasUnificationFeatureFlag,
    } = this.props;
    const isSmartGroup = activeGroupType && activeGroupType === 'Group::Smart';
    const headerButtonStyles = classNames('d-f ai-c', {
      ButtonWithTooltip: activeGroupCalculating,
    });

    return (
      <div className="PeopleHeader-buttonContainer">
        {canExportPeople && !hasUnificationFeatureFlag && (
          <ExportAllPeopleButton activeGroupId={activeGroupId} />
        )}
        <div className="Index-newButtonsContainer d-f jc-sb mt-16 u-hideBelowSM">
          {isSmartGroup && (
            <div
              className={headerButtonStyles}
              data-tooltip="Editing is disabled while group calculates."
            >
              {!hasUnificationFeatureFlag && this.editRulesButton()}
              {this.groupDetailsButton()}
              {activeGroupId && !hasUnificationFeatureFlag && (
                <CalculateInformation
                  groupId={activeGroupId}
                  calculating={activeGroupCalculating}
                  recalculationState={activeGroupRecalculationState}
                  refreshData={refreshData}
                  setGroupInMeta={setGroupInMeta}
                />
              )}
              {canExportPeople && hasUnificationFeatureFlag && (
                <ExportAllPeopleButton
                  activeGroupId={activeGroupId}
                  hasUnificationFeatureFlag={hasUnificationFeatureFlag}
                  isSmartGroup={isSmartGroup}
                />
              )}
            </div>
          )}
          {!isSmartGroup && (
            <div className="d-f jc-sb">
              {!hasUnificationFeatureFlag && this.editGroupMembersButton()}
              {this.groupDetailsButton()}
              {canExportPeople && hasUnificationFeatureFlag && (
                <ExportAllPeopleButton
                  activeGroupId={activeGroupId}
                  hasUnificationFeatureFlag={hasUnificationFeatureFlag}
                />
              )}
            </div>
          )}
          {this.addNewButtons()}
        </div>
        <div className="PeopleHeader-buttonContainer--mobile u-showBelowSM">
          {isSmartGroup && activeGroupId && !hasUnificationFeatureFlag && (
            <CalculateInformation
              groupId={activeGroupId}
              calculating={activeGroupCalculating}
              recalculationState={activeGroupRecalculationState}
              refreshData={refreshData}
              setGroupInMeta={setGroupInMeta}
            />
          )}
          <div className="d-f jc-sb">
            <div className="d-f ai-c">
              {this.groupDetailsButton()}
              {canExportPeople && hasUnificationFeatureFlag && (
                <div className="ml-8">
                  <ExportAllPeopleButton
                    activeGroupId={activeGroupId}
                    hasUnificationFeatureFlag={hasUnificationFeatureFlag}
                  />
                </div>
              )}
            </div>
            {canAddPeople && (
              <div className="PeopleHeader-actionButton">
                <button
                  type="button"
                  className="NewButton NewButton--white NewButton--center undecorated"
                  onClick={this.toggleMenu}
                >
                  Actions
                  <Icon
                    name="ellipsis-v"
                    className="PeopleHeader-actionButtonIcon ml-4 c-brand-gray-dark"
                  />
                </button>
                {this.state.isActive && (
                  <Popover dismissCallback={this.toggleMenu}>
                    {this.editRulesButton()}
                    {this.editGroupMembersButton()}
                    {this.addNewButtons()}
                  </Popover>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  canAddPeople:
    hasPermission(state, 'editGroups') ||
    get(state.data.permissions, 'canEditThisGroup', false),
  canExportPeople: hasPermission(state, 'manageAllGroups'),
  everyoneGroupId: state.data.meta.everyoneGroupId,
});

const mapDispatchToProps = dispatch => ({
  refreshData() {
    dispatch(actions.refreshData());
  },
  setGroupInMeta(data) {
    dispatch(actions.setGroupInMeta(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PeopleHeaderButtons);
